import { show, hide } from 'redux-modal'
import { APPOINTMENT_UNSUPPORTED_MODAL } from 'constant'

export const showAppointmentUnsupportedModal = ({ phoneNumber }) =>
  show(APPOINTMENT_UNSUPPORTED_MODAL, { phoneNumber })

export const hideAppointmentUnsupportedModal = () =>
  hide(APPOINTMENT_UNSUPPORTED_MODAL)
